import jwt from 'jwt-decode';

export function getDecodedToken(user) {
  if (!user || !user.idToken) return {};
  return jwt(user.idToken);
}

export function getProfileGroups(user, assumeuser) {
  if (!user || !user.idToken) return [];
  if (assumeuser !== null) return assumeuser.groups || [];
  return getDecodedToken(user)['cognito:groups'] || [];
}

export function getCognitoGroups(user) {
  if (!user || !user.idToken) return undefined;
  return getDecodedToken(user)['cognito:groups'];
}

export function getProfileFromToken(user) {
  if (!user || !user.idToken) {
    return {
      profileGroups: undefined,
      displayName: user?.username || '',
      fullName: '',
      email: '',
      initial: '?',
      picture: null,
    };
  }
  const profileToken = getDecodedToken(user);
  const profileGroups = profileToken['cognito:groups'];
  const givenName = trimmedClaim(profileToken['given_name']);
  const familyName = trimmedClaim(profileToken['family_name']);
  const fullName = [givenName, familyName].filter(Boolean).join(' ');
  const displayName = givenName || user.username || '';
  const email = profileToken['email'] || '';
  const initial =
    (displayName && String(displayName).trim().charAt(0).toUpperCase()) || '?';
  const picture =
    typeof profileToken['picture'] === 'string' &&
    /^https?:\/\//i.test(profileToken['picture'])
      ? profileToken['picture']
      : null;

  return {
    profileGroups,
    displayName,
    fullName,
    email,
    initial,
    picture,
  };
}

function trimmedClaim(value) {
  if (value == null) return '';
  return String(value).trim();
}

export const CHAT_PERMISSION_GROUP = 'CHAT';

export function hasChatPermission(user, assumeuser) {
  return getProfileGroups(user, assumeuser).includes(CHAT_PERMISSION_GROUP);
}
